// src/api/moduleApi.ts
import apiHandler from "../core/apiHandler";

// 📌 Todas las rutas estarán bajo /api/modules
const moduleApi = apiHandler("modules");

export default moduleApi;
